import React, { useEffect, useState } from "react";
import { ReactComponent as Contact } from "../../assets/contact.svg";
import { useHistory } from "react-router-dom";
import { getAsesorPicAPI } from "../../hyperFlow/hyperFlowApi";
import { ClipLoader } from "react-spinners";
import { BrandConfig } from "../asesorSlice";
export interface AsesorPreviewCardProps {
  wholeName: string;
  cargo?: string;
  asesorId: string;
  brandConfig: BrandConfig;
}

export const AsesorPreviewCard = (props: AsesorPreviewCardProps) => {
  const [userPic, setUserPic] = useState("");

  useEffect(() => {
    if (props.asesorId && userPic === "") {
      getAsesorPicAPI(props.asesorId)
        .then((response) => {
          if (response.asesorResponse) {
            setUserPic(response.asesorResponse.imgBase64);
          }
        })
        .catch((error) => {
          console.log(error);
          setUserPic("error");
        });
    }
  }, [props.asesorId, userPic]);
  const history = useHistory();
  return (
    <div
      onClick={() => {
        history.push(`/asesores?idAsesor=${props.asesorId}`);
      }}
      style={{
        width: "100%",
        minHeight: "92px",
        display: "flex",
        flexDirection: "row",
        cursor: "pointer",
        borderRadius: "20px",
        boxSizing: "border-box",
        padding: "10px 10px 10px 10px",
        margin: "8px 0 8px 0",
        backgroundColor: props.brandConfig.primaryButtonColor,
      }}
    >
      <div
        style={{
          maxWidth: "54px",
          maxHeight: "75px",
        }}
      >
        {userPic === "" ? (
          <ClipLoader
            color={
              props.brandConfig.primaryButtonTextColor ??
              props.brandConfig.secondaryTextColor
            }
            size={40}
          />
        ) : (
          <img
            alt="Imagen del asesor"
            src={`data:image/png;base64, ${userPic}`}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "cover",
              borderRadius: "30px",
            }}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "20px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <Contact
            color={
              props.brandConfig.primaryButtonTextColor ??
              props.brandConfig.secondaryTextColor
            }
            width={30}
            height={30}
          />
          <h6
            style={{
              color:
                props.brandConfig.primaryButtonTextColor ??
                props.brandConfig.secondaryTextColor,
              fontSize: "15px",
              fontWeight: 600,
              margin: 0,
              textAlign: "start",
            }}
          >
            {props.wholeName}
          </h6>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h6
            style={{
              color:
                props.brandConfig.primaryButtonTextColor ??
                props.brandConfig.secondaryTextColor,
              fontSize: "12px",
              fontWeight: 800,
              margin: 0,
              textAlign: "start",
            }}
          >
            {props.cargo || "ASESOR"}
          </h6>
          <div
            style={{
              padding: "2px 10px",
              backgroundColor:
                props.brandConfig.accentColor ??
                props.brandConfig.primaryButtonColor,
              borderRadius: "30px",
              textAlign: "center",
              fontSize: "11px",
              fontWeight: 800,
              color:
                props.brandConfig.primaryButtonTextColor ??
                props.brandConfig.secondaryTextColor ??
                "#fff",
            }}
          >
            Ver más
          </div>
        </div>
      </div>
    </div>
  );
};
